<template>
  <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel"
    width="800px">
    <a-form :model="formState" ref="formRef" :rules="rules" :label-col="{ style: { width: '100px' } }" layout="inline">
      <a-form-item class="mb-10" label="工序" name="name">
        <select-state type="processes" :value="formState.productionProcesses" placeholder="请选择工序"
          @handleSelect="handleSelect($event, 'productionProcesses')" style="width: 160px"></select-state>
      </a-form-item>

      <a-form-item class="mb-10" label="日期">
        <a-date-picker v-model:value="formState.localDate" placeholder="请选择识别日期" disabled allowClear
          @change="handleSelectDate($event, 'localDate')"></a-date-picker>
      </a-form-item>

      <a-form-item class="mb-10" label="过程功能" name="processFunction">
        <a-textarea v-model:value="formState.processFunction" auto-size placeholder="请输入过程功能" style="width: 600px"
          allowClear>
        </a-textarea>
      </a-form-item>

      <a-form-item class="mb-10" label="要求" name="">
        <a-textarea v-model:value="formState.requirement" auto-size placeholder="请输入要求" style="width: 600px"
          allowClear></a-textarea>
      </a-form-item>

      <a-form-item class="mb-10" label="失效模式" name="">
        <a-textarea v-model:value="formState.failureMode" auto-size placeholder="请输入失效模式" style="width: 600px"
          allowClear></a-textarea>
      </a-form-item>
      <a-form-item class="mb-10" label="失效影响" name="">
        <a-textarea v-model:value="formState.failureEffect" auto-size placeholder="请输入失效影响" style="width: 600px"
          allowClear></a-textarea>
      </a-form-item>
      <a-form-item class="mb-10" label="严重性" name="">
        <select-state type="serious" :value="formState.seriousness" placeholder="请选择严重性"
          @handleSelect="handleSelect($event, 'seriousness')" style="width: 460px"></select-state>
      </a-form-item>

      <a-form-item class="mb-10" label="失效原因" name="">
        <a-textarea v-model:value="formState.failureCause" style="width: 600px" placeholder="请输入失效原因" allowClear
          auto-size>
        </a-textarea>
      </a-form-item>
      <a-form-item class="mb-10" label="控制预防" name="">
        <a-textarea v-model:value="formState.controlAndPrevention" style="width: 600px" placeholder="请输入控制预防" allowClear
          auto-size>
        </a-textarea>
      </a-form-item>
      <a-form-item class="mb-10" label="发生频度" name="">
        <select-state type="frequency" :value="formState.frequency" placeholder="请选择发生频度"
          @handleSelect="handleSelect($event, 'frequency')" style="width: 460px"></select-state>
      </a-form-item>
      <a-form-item class="mb-10" label="控制探测" name="">
        <a-textarea v-model:value="formState.controlDetection" allowClear auto-size placeholder="请输入控制探测"
          style="width: 600px">
        </a-textarea>
      </a-form-item>

      <a-form-item class="mb-10" label="可探测度" name="">
        <select-state type="recurrent" :value="formState.detectability" placeholder="请选择可探测度"
          @handleSelect="handleSelect($event, 'detectability')" style="width: 460px"></select-state>
      </a-form-item>

      <a-form-item class="mb-10" label="RPN">
        <div style="width: 600px">{{ showExpireRPN }}</div>
      </a-form-item>

      <a-form-item class="mb-10" label="建议措施" name="">
        <a-textarea v-model:value="formState.suggestedMeasures" style="width: 600px" placeholder="请输入建议措施" allowClear
          auto-size>
        </a-textarea>
      </a-form-item>

      <a-form-item class="mb-10" label="过程责任人" name="">
        <a-textarea v-model:value="formState.personResponsible" style="width: 600px" placeholder="请输入过程责任" allowClear
          auto-size>
        </a-textarea>
      </a-form-item>
      <a-form-item class="mb-10" label="目标完成日期" name="">
        <a-date-picker v-model:value="formState.completionDate" placeholder="请选择目标完成日期"></a-date-picker>
      </a-form-item>
      <a-form-item class="mb-10" label="生效日期" name="">
        <a-date-picker v-model:value="formState.effectiveDate" placeholder="请选择生效日期"></a-date-picker>
      </a-form-item>
      <a-form-item class="mb-10" label="采取行动" name="">
        <a-textarea v-model:value="formState.takeAction" placeholder="请输入采取行动" style="width: 600px" allowClear
          auto-size>
        </a-textarea>
      </a-form-item>

      <a-form-item class="mb-10" label="行动严重性" name="">
        <select-state type="serious" :value="formState.resultsSeriousness" placeholder="请选择行动严重性"
          @handleSelect="handleSelect($event, 'resultsSeriousness')" style="width: 460px"></select-state>
      </a-form-item>
      <a-form-item class="mb-10" label="行动发生频度" name="">
        <select-state type="frequency" :value="formState.resultsFrequency" placeholder="请选择行动发生频度" style="width: 460px"
          @handleSelect="handleSelect($event, 'resultsFrequency')"></select-state>
      </a-form-item>
      <a-form-item class="mb-10" label="行动可探测度" name="">
        <select-state type="recurrent" :value="formState.resultsDetectability" placeholder="请选择行动可探测度"
          style="width: 460px" @handleSelect="handleSelect($event, 'resultsDetectability')"></select-state>
      </a-form-item>

      <a-form-item class="mb-10" label="行动RPN">
        <div style="width: 600px">{{ showActRPN }}</div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { computed, defineComponent, reactive, ref } from "vue";
import { savePfmea } from "@/request/view/trialProductionCenter";
import selectState from "@/views/trialProductionCenter/failureanalysis/component/selectState.vue";
import { debounce, timeStampToTime, Toast } from "@/utils";
import { useStore } from "vuex";

export default defineComponent({
  components: { selectState },
  setup(props, context) {
    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const user = useStore().state.user.user;

    const formState = reactive({
      id: null,
      // 项目
      projectLifeCycle: null,
      // 项目ID
      projectLifeCycleId: null,
      // 工序
      productionProcesses: null,
      // 过程
      processFunction: null,
      // 过程日期
      localDate: null,
      // 要求
      requirement: null,
      // 失效模式
      failureMode: null,
      // 失效影响
      failureEffect: null,
      // 严重性
      seriousness: null,
      // 失效原因
      failureCause: null,
      // 控制预防
      controlAndPrevention: null,
      // 发生频率
      frequency: null,
      // 控制探测
      controlDetection: null,
      // 可探测度
      detectability: null,
      // 失效RPN
      expireRPN: null,
      // 建议
      suggestedMeasures: null,
      // 责任
      personResponsible: null,
      // 目标完成日期
      completionDate: null,
      // 采取行动
      takeAction: null,
      // 生效日期
      effectiveDate: null,
      // 行动严重性
      resultsSeriousness: null,
      // 行动发生频度
      resultsFrequency: null,
      // 行动可探测度
      resultsDetectability: null,
      // 行动RPN
      actRPN: null,
      userId: null,
      username: null,
    });

    const rules = {
      processFunction: [
        {
          required: true,
          message: "请输入过程",
          trigger: "blur",
          type: "string",
        },
      ],
    };

    const formRef = ref();

    const showModal = (option) => {
      const { title, data, type } = option;

      if (type === "insert") {
        console.log(data);

        formState.projectLifeCycle = data.projectName;
        formState.projectLifeCycleId = data.projectId;

        formState.localDate = timeStampToTime("", "upload");
        formState.userId = user.id;
        formState.username = user.nickName;
      }

      if (
        (!formState.projectLifeCycle || !formState.projectLifeCycleId) &&
        type === "insert"
      ) {
        Toast("warning", "请选择项目", 3);
        return;
      }

      console.log(formState);

      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
      modalConfig.title = title;
      modalConfig.visible = true;
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.title = null;
      modalConfig.type = null;
      modalConfig.visible = false;
    };

    const handleOk = debounce(() => {
      formRef.value
        .validate()
        .then(() => {
          savePfmea(formState).then((res) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            handleCancel();
            context.emit("updateTable");
          });
        })
        .catch((err) => {
          console.log(err);
          if (err.errorFields && err.errorFields.length > 0) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });
    });
    const handleSelect = (e, type) => {
      formState[type] = e;
    };

    // 选择日期
    const handleSelectDate = (e, type) => {
      formState[type] = e.format("YYYY-MM-DD");
    };

    const showExpireRPN = computed(
      () =>
        formState.seriousness * formState.detectability * formState.frequency
    );
    const showActRPN = computed(
      () =>
        formState.resultsFrequency *
        formState.resultsDetectability *
        formState.resultsSeriousness
    );

    return {
      showModal,
      modalConfig,
      handleOk,
      handleCancel,
      handleSelect,
      handleSelectDate,
      showExpireRPN,
      showActRPN,
      formState,
      formRef,
      rules,
    };
  },
});
</script>

<style lang="less" scoped>
.mb-10 {
  margin-bottom: 10px;
}
</style>